import React, { Component } from 'react';
import SideMenu from '../admin/SideMenu';
import {appDatabasePrimaryFunctions} from '../../base';
import TopMenu from '../admin/TopBar';
import '../../styles/css/AdminMain.css';
import {findFirstAndLastName, convertTimeStampToHumanReadable} from '../utils/HelpfulFunction';
import DatePicker from '../utils/DatePicker';
import Papa from 'papaparse';
import swal from 'sweetalert2';

class AdminHome extends Component {
    constructor(props) {
        super(props);
        const todaysDateObject = new Date();
        todaysDateObject.setDate(todaysDateObject.getDate()-30);
        todaysDateObject.setHours(0,0,0,0); // Sets the time to start of the day (midnight)
        const endDateObject = new Date();
        endDateObject.setHours(23,59,59,999); // Sets the time to end of the day (11:59 pm)
        this.state = {
            games: 0,
            users: 0,
            itemsPerPage: 10,
            itemsToShow: 10,
            uniqueGamesUsers: 0,
            loading: false,
            players: 0,
            gameUsers: 0,
            prizesWon: 0,
            lastGame: {},
            uniqueGameUsers: false,
            gamesToShowList: [],
            searchStart: todaysDateObject,
            searchEnd: endDateObject
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange (evt) {
        const target = evt.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [target.name]: value
        });
    }

    componentDidMount() {
        this.getGames(this.state.searchStart.getTime());
        this.getUsers(this.state.searchStart.getTime());
    }

    async getGames(start = 0, end){
        const vm = this;
        let queryString = appDatabasePrimaryFunctions.ref('gamesList').orderByChild('timeStamp').startAt(start);
        let currentGame = null;
        let currentGameObject = await appDatabasePrimaryFunctions.ref('currentGame').once('value').then(function(snapshot){
            let gameTemp = snapshot.val();
            if(gameTemp && gameTemp.timeStamp > start){
                return gameTemp;
            } else {
                return null;
            }
        })
        if(end){
            queryString = queryString.endAt(end);
            if(currentGameObject && currentGameObject.timeStamp > end){
                currentGameObject = null;
            }
        }
        currentGame = currentGameObject;
        let currentGamePrizes = 0;
        let currentGameUsers = 0;
        let gamesCount = 0;
        if(currentGame){
            currentGamePrizes = currentGamePrizes + await appDatabasePrimaryFunctions.ref('emailsSent').once('value').then(function(snapshot){
                return snapshot.numChildren()
            })
            // currentGameUsers = currentGameUsers +  await appDatabasePrimaryFunctions.ref("userGameHistory").orderByChild(currentGame.id).equalTo(currentGame.id).once('value').then(function (snapshot){
            //     return snapshot.numChildren()
            // })
            const currentGameUsers = await appDatabasePrimaryFunctions.ref("userAnswers").once('value').then(function(snapshot){
                return snapshot.numChildren()
            })
            gamesCount++;
            currentGame.prizesWon = currentGamePrizes;
            currentGame.users = currentGameUsers;
            currentGame.currentGame = true;
        }
        queryString.once('value', function (snapshot) {
            let prizesCount = currentGamePrizes;
            let gameUsersCount = currentGameUsers;
            let gamesArray = [];
            let index = 0;
            snapshot.forEach(function (data) {
                index++;
                prizesCount += data.val().prizesWon || 0;
                gameUsersCount += data.val().users || 0;
                if(snapshot.numChildren() - vm.state.itemsPerPage < index){
                    gamesArray.unshift(data.val())
                }
            })
            if(currentGame){
                gamesArray.unshift(currentGame)
            }
            vm.setState({
                loading: false,
                games: gamesCount + snapshot.numChildren(),
                prizesWon: prizesCount,
                gameUsers: gameUsersCount,
                gamesToShowList: gamesArray
            })
        });
    }

    async getUsers(start=0, end, returnUsers=false){
        const vm = this;
        let queryString = appDatabasePrimaryFunctions.ref('users').orderByChild('signUpTime');
        if(start){
            queryString = queryString.startAt(start);
        }
        if(end){
            queryString = queryString.endAt(end);
        }
        if(returnUsers){
            return await queryString.once('value').then(function(snapshot) {
                if(snapshot.exists()){
                    return snapshot.val();
                } else {
                    return {};
                }
            })
        } else {
            let optInCounts = 0;
            queryString.once('value', function(snapshot){
                snapshot.forEach(function (data){
                    const user = data.val();
                    if(user.optIn || user.optInTwo || user.optInThree || user.optInFour){
                        optInCounts++;
                    }
                })
                vm.setState({
                    loading: false,
                    users: snapshot.numChildren(),
                    optIns: optInCounts
                })
            });
        }
    }

    async getUserData(onlyOptIns) {
        this.setState({ loading: true });
        let searchStart = this.state.searchStart || 0;
        let searchEnd = this.state.searchEnd;
        if (typeof searchStart === "object") {
            searchStart = searchStart.getTime();
        }
        if (searchEnd && typeof searchEnd === "object") {
            searchEnd = searchEnd.getTime();
        }

        const clientName = process.env.REACT_APP_CLEAN_CLIENT_NAME || process.env.REACT_APP_FIREBASE_PROJECT_ID;
        const dateGot = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000)
            .toISOString().split("T")[0];

        // Build CSV matrix as an array of arrays.
        // First, add metadata rows.
        const csvData = [];
        csvData.push([clientName, "Game"]); // Row 1: client/game info
        csvData.push([]); // Empty row
        csvData.push(["Date Data Downloaded", dateGot]);
        csvData.push(["From", searchStart ? convertTimeStampToHumanReadable(searchStart) : ""]);
        csvData.push(["To", searchEnd ? convertTimeStampToHumanReadable(searchEnd) : ""]);
        csvData.push([]); // Empty row before table

        // Table header row
        const headers = [
            "Email", "First Name", "Last Name", "Other First Name", "Other Last Name", "Zip Code", "Street", "City", "State", "Address",
            "Birthday", "Phone Number", "Social Handle", "Fan Response Text", "Fan Response Text 2", "Short Text Response 1", "Short Text Response 2",
            "Custom Dropdown", "Opt-In", "Opt-In 2", "Opt-In 3", "Opt-In 4", "YesNoQuestion", "YesExplanation", "YesNoQuestion2", "YesExplanation2",
            "YesNoQuestion3", "YesExplanation3", "How They Heard", "User Image", "UTM Campaign", "UTM Medium", "UTM Source", "SRC Code", "Signed Up"
        ];
        csvData.push(headers); // This is at index 6

        // Get users data
        let timeFrameUsers = await this.getUsers(searchStart, searchEnd, true);
        // Assuming timeFrameUsers is an object keyed by user IDs
        for (let key in timeFrameUsers) {
            let user = timeFrameUsers[key];
            if (onlyOptIns && !user.optIn && !user.optInTwo && !user.optInThree && !user.optInFour) {
                continue;
            }
            const [fn, ln]   = findFirstAndLastName(user.name||'');
            const [ofn, oln] = findFirstAndLastName(user.otherName||'');
            const row = [
                user.email || user.id || "",
                fn || "",
                ln || "",
                ofn || "",
                oln || "",
                user.zipCode || "",
                user.street || "",
                user.city || "",
                user.state || "",
                user.address || "",
                user.birthday || "",
                user.phoneNumber || "",
                user.socialHandle || "",
                user.fanResponseToCollectTextInput || "",
                user.fanResponseToCollectTextInput2 || "",
                user.textInputOne || "",
                user.textInputTwo || "",
                user.customDropdownInput || "",
                user.optIn || "",
                user.optInTwo || "",
                user.optInThree || "",
                user.optInFour || "",
                user.yesNoQuestions || "",
                user.yesExplanation || "",
                user.yesNoQuestions2 || "",
                user.yesExplanation2 || "",
                user.yesNoQuestions3 || "",
                user.yesExplanation3 || "",
                user.howYouHeard || "",
                user.userImage || "",
                user.utmCampaign || "",
                user.utmMedium || "",
                user.utmSource || "",
                user.srcCode || "",
                user.signUpTime ? convertTimeStampToHumanReadable(user.signUpTime) : ""
            ];
            csvData.push(row);
        }

        // Remove empty columns from the table portion.
        const isEmpty = value => value === undefined || value === null || value === "" || value === "NONE";
        const headerIndex = 6; // The table header row we just added.
        const tableHeaders = csvData[headerIndex];
        const tableRows = csvData.slice(headerIndex + 1);
        const indicesToKeep = [];
        for (let i = 0; i < tableHeaders.length; i++) {
            if (tableRows.some(row => !isEmpty(row[i]))) {
                indicesToKeep.push(i);
            }
        }
        const filteredHeaders = indicesToKeep.map(i => tableHeaders[i]);
        const filteredRows = tableRows.map(row => indicesToKeep.map(i => row[i]));
        // Rebuild final CSV matrix: keep the metadata rows intact.
        const finalCsvData = csvData.slice(0, headerIndex);
        finalCsvData.push(filteredHeaders);
        finalCsvData.push(...filteredRows);

        // Convert the array-of-arrays to CSV text and trigger download.
        const csvContent = Papa.unparse(finalCsvData);
        const hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
        hiddenElement.target = '_blank';
        let cleanString =
            (searchStart ? "_" + convertTimeStampToHumanReadable(searchStart) : "") +
            (searchEnd ? "_" + convertTimeStampToHumanReadable(searchEnd) : "");
        cleanString = "prediction_accounts_made" + cleanString.replace(/[|&;$%@"<>()+,]/g, "").toLowerCase() + ".csv";
        hiddenElement.download = cleanString;
        hiddenElement.click();
        this.setState({ loading: false });
    }

    async downloadIntenseGameData(game) {
        this.setState({ loading: true });
        const clientName = process.env.REACT_APP_FAN_LINK;
        const dateDownloaded = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000)
            .toISOString().split("T")[0];

        // Build CSV matrix with metadata rows.
        const csvData = [];
        csvData.push([clientName, "Prediction"]); // Metadata row 1
        csvData.push([]); // Empty row
        csvData.push(["Date Data Downloaded", dateDownloaded]);
        csvData.push(["Game Name", game.gameName]);
        csvData.push(["Start Time", game.scheduleInfo ? convertTimeStampToHumanReadable(game.scheduleInfo.performAt) : ""]);
        csvData.push(["End Time", game.scheduleInfo ? convertTimeStampToHumanReadable(game.scheduleInfo.endAt) : ""]);

        const gameAnswers = await appDatabasePrimaryFunctions.ref(`userAnswersHistory/${game.id}`).once('value').then(function(snapshot){
            if(snapshot.exists()){
                return snapshot.val();
            } else {
                return []
            }
        });
        let totalPrizes = 0;
        for (let key in gameAnswers) {
            const userInfo = gameAnswers[key];
            if (userInfo.rewardSent) {
                totalPrizes++;
            }
        }
        csvData.push(["Prizes Won", totalPrizes.toString()]);
        csvData.push([]); // Empty row to separate metadata from table

        // Table header row
        const headers = [
            'Email', 'First Name', 'Last Name', 'Other First Name', 'Other Last Name',
            'Zip Code', 'Street', 'City', 'State', 'Address', 'Birthday', 'Phone Number',
            'Social Handle', 'Fan Response Text', 'Fan Response Text 2', 'Short Text Response 1',
            'Short Text Response 2', 'Custom Dropdown', 'Opt-In', 'Opt-In 2', 'Opt-In 3',
            'Opt-In 4', 'YesNoQuestion', 'YesExplanation', 'YesNoQuestion2', 'YesExplanation2',
            'YesNoQuestion3', 'YesExplanation3', 'How They Heard', 'User Image', 'UTM Campaign',
            'UTM Medium', 'UTM Source', 'SRC Code', 'Answer', 'Correct', 'Reward', 'Code', "Link", "Answer Time",
            'Redeemed'
        ];
        csvData.push(headers); // Table header row at index 8

        const usersData = await appDatabasePrimaryFunctions.ref('users').once('value').then(function(usersSnapshot){
            return usersSnapshot.val();
        })
        // Build table rows from gameAnswers.
        for (let key in gameAnswers) {
            const userInfo = gameAnswers[key];
            const correct = parseInt(userInfo.answer) === parseInt(game.correctAnswer) ? "YES": "NO";
            const moreUserData = usersData[userInfo.uid];
            const [fn, ln]   = findFirstAndLastName(moreUserData.name||'');
            const [ofn, oln] = findFirstAndLastName(moreUserData.otherName||'');
            const row = [
                moreUserData.email || moreUserData.id || '',
                fn || '',
                ln || '',
                ofn || '',
                oln || '',
                moreUserData.zipCode || '',
                moreUserData.street || '',
                moreUserData.city || '',
                moreUserData.state || '',
                moreUserData.address || '',
                moreUserData.birthday || '',
                moreUserData.phoneNumber || '',
                moreUserData.socialHandle || '',
                moreUserData.fanResponseToCollectTextInput || '',
                moreUserData.fanResponseToCollectTextInput2 || '',
                moreUserData.textInputOne || '',
                moreUserData.textInputTwo || '',
                moreUserData.customDropdownInput || '',
                moreUserData.optIn || '',
                moreUserData.optInTwo || '',
                moreUserData.optInThree || '',
                moreUserData.optInFour || '',
                moreUserData.yesNoQuestions || '',
                moreUserData.yesExplanation || '',
                moreUserData.yesNoQuestions2 || '',
                moreUserData.yesExplanation2 || '',
                moreUserData.yesNoQuestions3 || '',
                moreUserData.yesExplanation3 || '',
                moreUserData.howYouHeard || '',
                moreUserData.userImage || '',
                moreUserData.utmCampaign || '',
                moreUserData.utmMedium || '',
                moreUserData.utmSource || '',
                moreUserData.srcCode || '',
                userInfo.answer || '',
                userInfo.correct || '',
                userInfo.rewardSent || '',
                userInfo.code || '',
                userInfo.link || "",
                convertTimeStampToHumanReadable(parseInt(userInfo.timeStamp)),
                userInfo.isRedeemed ? 'true' : ''
            ];
            csvData.push(row);
        }

        // Remove empty columns from the table portion.
        // The table header row is at index 8.
        const headerIndex = 8;
        const tableHeaders = csvData[headerIndex];
        const tableRows = csvData.slice(headerIndex + 1);
        const isEmpty = value => value === undefined || value === null || value === "" || value === "NONE";
        const indicesToKeep = [];
        for (let i = 0; i < tableHeaders.length; i++) {
            if (tableRows.some(row => !isEmpty(row[i]))) {
                indicesToKeep.push(i);
            }
        }
        const filteredHeaders = indicesToKeep.map(i => tableHeaders[i]);
        const filteredRows = tableRows.map(row => indicesToKeep.map(i => row[i]));
        const finalCsvData = csvData.slice(0, headerIndex);
        finalCsvData.push(filteredHeaders);
        finalCsvData.push(...filteredRows);

        // Generate CSV content and trigger download.
        const csvContent = Papa.unparse(finalCsvData);
        const hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
        hiddenElement.target = '_blank';
        let cleanString = game.gameName.replace(/[|&;$%@"<>()+,. ]/g, "").toLowerCase();
        hiddenElement.download = "game_data_" + cleanString + ".csv";
        hiddenElement.click();
        this.setState({ loading: false });
    }

    searchData(){
        let searchStart = this.state.searchStart;
        let searchEnd = this.state.searchEnd;
        if(searchStart){
            searchStart = searchStart.getTime();
        }
        if(searchEnd){
            searchEnd = searchEnd.getTime();
        }
        this.setState({
            loading: true,
            itemsPerPage: this.state.itemsPerPage
        }, ()=>{

        })
        this.getGames(searchStart,searchEnd)
        this.getUsers(searchStart,searchEnd)
    }

    onNextPage() {
        const vm = this;
        const newAmountToShow = this.state.itemsToShow + this.state.itemsPerPage;
        let searchStart = this.state.searchStart;
        let searchEnd = this.state.searchEnd;
        if(searchStart){
            searchStart = searchStart.getTime();
        }
        if(searchEnd){
            searchEnd = searchEnd.getTime();
        }
        let queryString = appDatabasePrimaryFunctions.ref('gamesList').orderByChild('timeStamp').limitToLast(newAmountToShow).startAt(searchStart);
        if (searchEnd) {
            queryString = queryString.endAt(searchEnd)
        }
        queryString.once('value', function (snapshot) {
            let gamesArray = [];
            snapshot.forEach(function (data) {
                gamesArray.unshift(data.val())
            })
            vm.setState({
                itemsToShow: newAmountToShow,
                gamesToShowList: gamesArray
            });
        })
    }

    async deleteGame(gameToDelete) {
        if (!gameToDelete || !gameToDelete.id) {
            swal('Error!', 'No game ID provided.', 'error');
            return;
        }

        const responseFromPopUp = await swal({
            title: 'WARNING!',
            text: 'This will delete ALL data associated with the game. Are you sure you want to do this?',
            type: 'warning',
            input: 'text',
            inputPlaceholder: 'Type DELETE to confirm',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            preConfirm: (inputValue) => {
                if (inputValue !== 'DELETE') {
                    swal.showValidationMessage('You need to type DELETE to confirm');
                    return false;
                }
            }
        });

        if (!responseFromPopUp || !responseFromPopUp.value) return;

        this.setState({ loading: true });

        const removeNodesByGameId = async (refPath, gameIdField, isNested = false) => {
            const ref = appDatabasePrimaryFunctions.ref(refPath).orderByChild(gameIdField).equalTo(gameToDelete.id);
            const snapshot = await ref.once('value');

            if (snapshot.exists()) {
                const nodes = snapshot.val();
                const chunkSize = 50;
                let currentChunk = {};

                for (const key in nodes) {
                    if (isNested) {
                        for (const nestedKey in nodes[key]) {
                            currentChunk[`${refPath}/${key}/${nestedKey}`] = null;
                            if (Object.keys(currentChunk).length >= chunkSize) {
                                await appDatabasePrimaryFunctions.ref().update(currentChunk);
                                currentChunk = {};
                            }
                        }
                    } else {
                        if(refPath === 'userGameHistory'){
                            currentChunk[`${refPath}/${key}/${gameIdField}`] = null;
                        } else {
                            currentChunk[`${refPath}/${key}`] = null;
                        }
                        if (Object.keys(currentChunk).length >= chunkSize) {
                            await appDatabasePrimaryFunctions.ref().update(currentChunk);
                            currentChunk = {};
                        }
                    }
                }

                if (Object.keys(currentChunk).length > 0) {
                    await appDatabasePrimaryFunctions.ref().update(currentChunk);
                }
            }
        };

        try {
            try {
                const userAnswersHistoryRef = appDatabasePrimaryFunctions.ref(`userAnswersHistory/${gameToDelete.id}`);
                await userAnswersHistoryRef.remove();
            } catch (error) {
                await removeNodesByGameId(`userAnswersHistory/${gameToDelete.id}`, 'gameId', true);
            }

            const gameRef = appDatabasePrimaryFunctions.ref('gamesList').orderByChild('id').equalTo(gameToDelete.id);
            const snapshot = await gameRef.once('value');

            if (snapshot.exists()) {
                const gameKey = Object.keys(snapshot.val())[0];
                await appDatabasePrimaryFunctions.ref(`gamesList/${gameKey}`).remove();

                // userGameHistory: skipping deletion - data structure doesn't support efficient querying
                // and reading all users would be too expensive for large datasets

                await removeNodesByGameId('redeemedPrize', 'gameId');

                this.setState({
                    gamesToShowList: this.state.gamesToShowList.filter(game => game.id !== gameToDelete.id)
                });

                swal('Deleted!', 'The game has been deleted.', 'success');
            } else {
                swal('Error!', 'Game not found.', 'error');
            }
        } catch (error) {
            swal('Error!', 'An error occurred while deleting the game.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const totalUsers = this.state.users || 0;
        const optIns = this.state.optIns || 0;
        const gameUsers = this.state.gameUsers || 0;
        const prizesWon = this.state.prizesWon || 0;
        const fan_side_link = process.env.REACT_APP_FAN_LINK || "";
        const isSqwadEmployee = this.props.isSqwadEmployee || false;
        return (
          <div className="admin-wrapper">
            <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
            <SideMenu/>
            <TopMenu/>
            <div className="admin-main-panel">
                <div className="row" style={{width:'100%'}}>
                    <div className="col-md-11">
                        <p className="admin-header-text" style={{marginTop:'10px'}}>Game link: <span style={{fontSize:'20px'}}>{fan_side_link}</span></p>
                    </div>
                    <div className="col-md-1">
                        <p style={{color: "black"}}>
                            v{process.env.REACT_APP_VERSION}
                        </p>
                    </div>
                </div>
                <form className="form-horizontal" style={{ marginLeft: 20, marginBottom: 10 }}>
                    <div className="row g-3 align-items-center">
                        <div className="col-auto">
                            <DatePicker
                                isClearable
                                selected={this.state.searchStart}
                                onChange={date => {
                                    if (date) date.setHours(0, 0, 0, 0);
                                    this.setState({ searchStart: date });
                                }}
                            />
                        </div>

                        <div className="col-auto">
                            <DatePicker
                                isClearable
                                selected={this.state.searchEnd}
                                onChange={date => {
                                    if (date) date.setHours(23, 59, 59, 999);
                                    this.setState({ searchEnd: date });
                                }}
                            />
                        </div>
                        <div className="col-auto">
                            <button className="btn btn-primary btn-admin" type="button" onClick={() => this.searchData()}>Search</button>
                        </div>
                    </div>
                </form>
                <div className="admin-grid-container four-columns">
                    <div className="card card-styles text-xs-center" style={{backgroundColor:"black"}}>
                        <div className="card-body">
                            <blockquote className="card-bodyquote" style={{margin:0}}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <p style={{color:"white", fontSize:50, margin:0}}>{totalUsers}</p>
                                        <span style={{color:"#f8f8ff", fontSize:20}}>Accounts Created</span>
                                    </div>
                                    {isSqwadEmployee &&
                                        <div className="col-md-4" style={{fontSize:40, alignSelf:"center"}}>
                                            <i className="fa fa-arrow-circle-o-down" aria-hidden="true" style={{color:"white", cursor: "pointer"}} onClick={()=> this.getUserData()}/>
                                        </div>
                                    }
                                </div>
                            </blockquote>
                        </div>
                    </div>
                    <div className="card card-styles text-xs-center" style={{backgroundColor:"black"}}>
                        <div className="card-body">
                            <blockquote className="card-bodyquote" style={{margin:0}}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <p style={{color:"white", fontSize:50, margin:0}}>{optIns}</p>
                                        <span style={{color:"#f8f8ff", fontSize:20}}>Opt Ins</span>
                                    </div>
                                    {optIns > 0 &&
                                        <div className="col-md-4" style={{fontSize: 40, alignSelf: "center"}}>
                                            <i className="fa fa-arrow-circle-down" aria-hidden="true" style={{color: "white", cursor: "pointer"}} onClick={() => this.getUserData(true)}/>
                                        </div>
                                    }
                                </div>
                            </blockquote>
                        </div>
                    </div>
                    <div className="card card-styles text-xs-center" style={{backgroundColor:"black"}}>
                        <div className="card-body">
                            <blockquote className="card-bodyquote" style={{margin:0}}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <p style={{color:"white", fontSize:50, margin:0}}>{gameUsers}</p>
                                        <span style={{color:"#f8f8ff", fontSize:20}}>Game Users</span>
                                    </div>
                                </div>
                            </blockquote>
                        </div>
                    </div>
                    <div className="card card-styles text-xs-center" style={{backgroundColor:"black"}}>
                        <div className="card-body">
                            <blockquote className="card-bodyquote" style={{margin:0}}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <p style={{color:"white", fontSize:50, margin:0}}>{prizesWon}</p>
                                        <span style={{color:"#f8f8ff", fontSize:20}}>Prizes Won</span>
                                    </div>
                                </div>
                            </blockquote>
                        </div>
                    </div>
                </div>
                <div style={{margin:20}}>
                    {this.state.gamesToShowList && this.state.gamesToShowList.length > 0 &&
                    <>
                        {
                            this.state.gamesToShowList.map(function (item, index) {
                                return (
                                    <div key={index} className="card card-styles text-xs-center"
                                         style={{marginBottom: 10}}>
                                        <div className="card-body"
                                             style={{boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px"}}>
                                            <div className="row" style={{alignItems: 'center'}}>
                                                <div className="col-md-2">
                                                    <span style={{color: 'black', fontSize: 14}}>{convertTimeStampToHumanReadable(item.timeStamp)}</span>
                                                </div>
                                                <div className="col-md-3" style={{fontSize: 30}}>
                                                    {item.gameName}
                                                </div>
                                                <div className="col-md-3" style={{textAlign: 'right'}}>
                                                    <span style={{fontSize: 25}}>{item.users || 0}</span>
                                                    <span style={{color: 'black', fontSize: 15, marginRight: 15}}>Played</span>
                                                    <span style={{fontSize: 25}}>{item.prizesWon || 0}</span>
                                                    <span style={{color: 'black', fontSize: 15}}>Prizes Won</span>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="row" style={{fontSize: 20, justifyContent: 'flex-end'}}>
                                                        {item.prizesWon !== null && !item.currentGame &&
                                                            <div className="col-auto">
                                                                <button onClick={() => this.downloadIntenseGameData(item)} className="export-button-styles btn btn-primary btn-lg download-button mobile-hide">
                                                                    <span className="fa fa-arrow-circle-down"/> Download Game Data
                                                                </button>
                                                            </div>
                                                        }
                                                        {item.currentGame &&
                                                            <div className="col-auto">
                                                                <button onClick={() => window.location.href='/setupgame'} className="export-button-styles btn btn-primary btn-lg download-button mobile-hide">
                                                                    Go To Current Game
                                                                </button>
                                                            </div>
                                                        }
                                                        {!item.currentGame &&
                                                            <div className="col-auto">
                                                                <button onClick={() => this.deleteGame(item)} className="btn btn-danger btn-lg">
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }, this)
                        }
                        {this.state.games > this.state.gamesToShowList.length &&
                            <button className="btn btn-primary" onClick={()=>this.onNextPage()}>
                                More
                            </button>
                        }
                    </>
                    }
                </div>
            </div>
         </div>
        );
    }
}

export default AdminHome
